// extracted by mini-css-extract-plugin
export default {"row":"IdDocuments_row__nfSlT"};